var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CardAdvancement, CardGrade } from '@cta-portal/webapp-common/lib/api/schema';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import React from 'react';
import styled from 'styled-components';
import { CurrencyTokenSymbol, currencyTokens } from '../../data/currency-tokens/currency-tokens';
import { TokenType } from '../../types/common';
import { elementAssets, foilAssets, gradeAssets } from '../../utils/cards-metadata-assets';
import { currencyTokenAssets } from '../../utils/currency-token-assets';
import { getAvailableRanksFromRarity } from '../../utils/products';
import Button from '../common/button';
import FiltersRow, { FiltersRowType } from './filters-row';
export default function Filters(_a) {
    var filters = _a.filters, tokenType = _a.tokenType, availableElements = _a.availableElements, advancement = _a.advancement, rarity = _a.rarity, withoutFiltersMetadata = _a.withoutFiltersMetadata;
    var t = useI18n().t;
    function onChangeSelectedTokens(currencyToken) {
        var _value = __spreadArray([], filters.state.currencyTokensTmp, true);
        var index = _value.indexOf(currencyToken);
        if (index === -1) {
            _value.push(currencyToken);
        }
        else {
            _value.splice(index, 1);
        }
        filters.actions.setCurrencyTokens(_value);
    }
    function onChangeElements(element) {
        var _value = __spreadArray([], filters.state.elementsTmp, true);
        var index = _value.indexOf(element);
        if (index === -1) {
            _value.push(element);
        }
        else {
            _value.splice(index, 1);
        }
        filters.actions.setElements(_value);
    }
    function onChangeFoil(foil) {
        var _value = __spreadArray([], filters.state.foilsTmp, true);
        var index = _value.indexOf(foil);
        if (index === -1) {
            _value.push(foil);
        }
        else {
            _value.splice(index, 1);
        }
        filters.actions.setFoils(_value);
    }
    function onChangeRank(rank) {
        var _value = __spreadArray([], filters.state.ranksTmp, true);
        var index = _value.indexOf(rank);
        if (index === -1) {
            _value.push(rank);
        }
        else {
            _value.splice(index, 1);
        }
        filters.actions.setRanks(_value);
    }
    function onChangeGrade(grade) {
        var _value = __spreadArray([], filters.state.gradesTmp, true);
        var index = _value.indexOf(grade);
        if (index === -1) {
            _value.push(grade);
        }
        else {
            _value.splice(index, 1);
        }
        filters.actions.setGrades(_value);
    }
    var availableRanks = getAvailableRanksFromRarity(rarity, undefined);
    var currencyItems = currencyTokens
        .filter(function (token) { return token.symbol === CurrencyTokenSymbol.CTA || token.symbol === CurrencyTokenSymbol.USDC; })
        .map(function (token) { return ({
        type: FiltersRowType.CURRENCY_TOKEN,
        icon: currencyTokenAssets[token.symbol],
        action: function () { return onChangeSelectedTokens(token.symbol); },
        selected: filters.state.currencyTokensTmp.includes(token.symbol),
    }); });
    var elementItems = availableElements
        ? availableElements.map(function (element) { return ({
            type: FiltersRowType.ELEMENT,
            icon: elementAssets[element],
            action: function () { return onChangeElements(element); },
            selected: filters.state.elementsTmp.includes(element),
        }); })
        : [];
    var foilItems = [
        {
            type: FiltersRowType.FOIL,
            icon: foilAssets.true,
            action: function () { return onChangeFoil(true); },
            selected: filters.state.foilsTmp.includes(true),
        },
        {
            type: FiltersRowType.FOIL,
            icon: foilAssets.false,
            action: function () { return onChangeFoil(false); },
            selected: filters.state.foilsTmp.includes(false),
        },
    ];
    var rankItems = availableRanks.map(function (rank) { return ({
        type: FiltersRowType.RANK,
        icon: '',
        action: function () { return onChangeRank(rank); },
        selected: filters.state.ranksTmp.includes(rank),
        value: rank,
    }); });
    var gradeItems = [
        {
            type: FiltersRowType.GRADE,
            icon: gradeAssets[CardGrade.C],
            action: function () { return onChangeGrade(CardGrade.C); },
            selected: filters.state.gradesTmp.includes(CardGrade.C),
        },
        {
            type: FiltersRowType.GRADE,
            icon: gradeAssets[CardGrade.B],
            action: function () { return onChangeGrade(CardGrade.B); },
            selected: filters.state.gradesTmp.includes(CardGrade.B),
        },
        {
            type: FiltersRowType.GRADE,
            icon: gradeAssets[CardGrade.A],
            action: function () { return onChangeGrade(CardGrade.A); },
            selected: filters.state.gradesTmp.includes(CardGrade.A),
        },
        {
            type: FiltersRowType.GRADE,
            icon: gradeAssets[CardGrade.S],
            action: function () { return onChangeGrade(CardGrade.S); },
            selected: filters.state.gradesTmp.includes(CardGrade.S),
        },
    ];
    return (_jsxs(Container, { children: [_jsx(ApplyContainer, { visible: false, children: _jsx(Button, { highlighted: true, onClick: filters.actions.applyFilters, children: t('filters.apply-filters') }) }), _jsx(FiltersRow, { items: currencyItems, label: t('common.currency'), withoutSeparator: true }), !withoutFiltersMetadata && (_jsxs(_Fragment, { children: [tokenType === TokenType.CARD && availableElements && availableElements.length > 1 && (_jsx(FiltersRow, { items: elementItems, label: t('filters.element') })), (tokenType === TokenType.CARD || tokenType === TokenType.SOUVENIR_CARD) && (_jsx(FiltersRow, { items: foilItems, label: t('filters.foil') })), tokenType === TokenType.CARD && advancement === CardAdvancement.STANDARD && (_jsx(FiltersRow, { items: rankItems, label: t('filters.rank') })), tokenType === TokenType.CARD && advancement !== CardAdvancement.STANDARD && (_jsx(FiltersRow, { items: gradeItems, label: t('filters.grade') }))] }))] }));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  position: relative;\n  width: 100%;\n"], ["\n  align-items: center;\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  position: relative;\n  width: 100%;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.layoutNeutralDark;
});
var ApplyContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  align-items: center;\n  border-bottom: ", ";\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n  height: ", ";\n  justify-content: center;\n  overflow: hidden;\n  padding: 0 16px;\n  transition: height 200ms ease-in-out;\n  width: 100%;\n"], ["\n  align-items: center;\n  border-bottom: ", ";\n  background-color: ", ";\n  display: flex;\n  flex-direction: column;\n  height: ", ";\n  justify-content: center;\n  overflow: hidden;\n  padding: 0 16px;\n  transition: height 200ms ease-in-out;\n  width: 100%;\n"])), function (_a) {
    var visible = _a.visible, theme = _a.theme;
    return (visible ? "solid 1px ".concat(theme.palette.purple) : 'none');
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.layoutNeutralDark;
}, function (_a) {
    var visible = _a.visible;
    return (visible ? '64px' : '0');
});
var templateObject_1, templateObject_2;
